import {
    collection,
    getDocs,
    addDoc,
    doc, 
    deleteDoc,
  } from "firebase/firestore";
  
  import {db} from "../../firebase-config";

  const LOAD = "meme/LOAD";
  const CREATE = "meme/CREATE";
  const DELETE = "meme/DELETE";
  
  const initialState = {
    list: [],
  };
  
  function loadMeme(payload){
    return {type: LOAD, payload};
  }

  function createMeme(payload){
      return {type: CREATE, payload: payload};
  }

  // function deleteMeme(payload){
  //   return {type: DELETE, payload};
  // }

  export const loadMemeFB = () => {
    return async function (dispatch) {
      const meme_data = await getDocs(collection(db, "meme"));
      let meme_list  = []; 
  
      meme_data.forEach((doc) => { 
        meme_list.push({ id: doc.id, ...doc.data() }); 
      });
      dispatch(loadMeme(meme_list));
    }
  }
  
  export const addMemeFB = (meme) => {
    return async function (dispatch) {
          // 파이어스토어에 추가하기를 기다려요!
      const docRef = await addDoc(collection(db, "meme"), meme);
          // 추가한 데이터 중 id를 가져와서 bucket_data를 만들어줬어요!
      const meme_data = { id: docRef.id, ...meme };
          // 그럼 이제 액션을 일으키자! (수정해달라고 요청하자!)
      dispatch(createMeme(meme_data));
    }
  }

  export const deleteMemeFB = (meme_id) => {
    return async function (dispatch, getState) {
      if(!meme_id){
        window.alert("아이디가 없네요!");
        return;
      }
      const docRef = doc(db, "meme", meme_id);
      await deleteDoc(docRef);
      console.log(docRef);

      dispatch(loadMemeFB());

      // 1. 삭제한 다음에, 나머지를 가진 배열을 get -> 리덕스 업데이트
      // 2. 삭제하고, 리덕스에서 삭제한걸 같이제거, 
      // 3. 가져오는 sorting으로 id 가져올때 

      //  //const _meme_list = getState().meme.list;
      //  const meme_index = getState().meme.findIndex((b) => {
      //    return b.id === meme_id;
      //  });
      //  console.log(meme_index)
  
      //  dispatch(deleteMeme(meme_index));
      // window.location.replace("/")
    }
  }
  
  export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
      case LOAD:{
        return {list: action.payload}
      }
        case CREATE: {
          const new_meme_list = [...state.list, action.payload];
          return {list : new_meme_list};
      }   
        case DELETE: {
          const new_meme_list = state.list.filter((l, idx) => {
          return parseInt(action.payload) !== idx;
        });
        return {list: new_meme_list};
      }
        default:
          return state;
    }
  }